<template>
  <div style="display: inline-block;">
    <div class="plate">
      <div>
        <span class="number">{{ value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: String, default: "00-XX-000" },
  },
};
</script>

<style scoped>
.plate {
  display: block;
  width: 250px;
  height: 55px;
  background: url("/dqn.svg");
  background-size: 250px;
  padding-top: 12px;
  text-align: center;
  background-repeat: no-repeat;
}

.number {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 48px;
  padding-left: 25px;
}
</style>
